import { useEffect, useState } from 'react'
import HyperLiquidClient from '../../clients/HyperLiquidClient'
import { logger } from '../../logger'
import { executeAndSetInterval } from '../../utils/executeAndSetInterval'

const REFRESH_FREQUENCY = 3000

interface PerpMeta {
  price: number
  funding: number
  dayVolume: number
  markPrice: number
  openInterest: number
}

export const usePerpAssetMeta = (assetId: number) => {
  const [meta, setMeta] = useState<PerpMeta>()

  useEffect(() => {
    const loadMeta = async () => {
      const client = new HyperLiquidClient()
      const tokens = await client.getAssetContext()

      return tokens[assetId]
    }

    const clearFetch = executeAndSetInterval(async () => {
      try {
        const { oraclePx, markPx, dayNtlVlm, funding, openInterest } = await loadMeta()

        const price = parseFloat(oraclePx)

        setMeta({
          price,
          markPrice: parseFloat(markPx),
          dayVolume: parseFloat(dayNtlVlm),
          funding: parseFloat(funding),
          openInterest: parseFloat(openInterest) * price,
        })
      } catch (e) {
        logger.error('Error fetching perps tokens meta', { originalError: e })
      }
    }, REFRESH_FREQUENCY)

    return () => {
      clearFetch()
    }
  }, [assetId])

  return { meta }
}
